import { flatten } from 'flat';
import { useQueryClient } from 'react-query';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { QUERY_KEYS } from 'api/certificates/queries';
import {
  DocumentDetailsModel,
  DocumentModel,
  DOCUMENT_PUBLICATION_STATUS,
} from 'api/documents/documents.model';
import { CertificateDetailsModel } from 'models/certificate.model';

const useDocumentTableRow = (selectedTab?: string) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient();

  const onRowClick = ({
    documentBlockchainAddress,
    documentPublicationStatus,
    jobId,
  }: DocumentModel<CertificateDetailsModel>) => {
    const state = queryClient.getQueryState<DocumentDetailsModel<CertificateDetailsModel>>([
      QUERY_KEYS.GET_CERTIFICATE,
      jobId,
    ]);

    return (
      [documentPublicationStatus, state?.data?.documentPublicationStatus].includes(
        DOCUMENT_PUBLICATION_STATUS.PUBLISHING_OK
      ) &&
      navigate(
        `${pathname.split('/', 3).join('/')}/${
          documentBlockchainAddress ?? state?.data?.documentBlockchainAddress
        }`,
        {
          state: {
            searchParams: flatten({ ...Object.fromEntries([...searchParams]) }),
            selectedTab,
          },
        }
      )
    );
  };

  return { onRowClick };
};

export default useDocumentTableRow;
